import { HttpClient, HttpEvent, HttpParams, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import {
  SubjectModel,
  SubjectModelClone,
  SubjectModelListItem,
  SubjectModelNew,
  SubjectModelUpdate
} from '../../_objects/subject-model';
import { HttpService } from '../http.service';
import { SubjectModelContractService } from '../interfaces/subject-model-contract.service';
import { ElectronService } from '../../electron.service';

@Injectable({
  providedIn: 'root'
})
export class SubjectModelOnlineService extends HttpService implements SubjectModelContractService {

  constructor(
    private http: HttpClient,
    cookieService: CookieService,
    router: Router) {
    super();
    super.setCookieService(cookieService);
    super.setHttpClient(http);
    super.setRouter(router);
  }

  // MD01 GET /api/v1/models
  getSubjectModels(enabledOnly?: boolean, aliveOnly?: boolean): Observable<SubjectModelListItem[]> {
    const endpoint = super.getEndpoint('models');

    let httpParams = new HttpParams();
    if (enabledOnly !== null && enabledOnly !== undefined) {
      httpParams = httpParams.set('enabledOnly', String(enabledOnly));
    }
    if (aliveOnly !== null && aliveOnly !== undefined) {
      httpParams = httpParams.set('aliveOnly', String(aliveOnly));
    }

    return this.http.get<SubjectModel[]>(endpoint,
      { withCredentials: super.getWithCredentialsOption(), params: httpParams })
      .pipe(map(response => response as SubjectModelListItem[]));
  }

  // MD02 GET /api/v1/models/{modelId}
  getSubjectModel(id: string, version?: number, enabledOnly?: boolean, aliveOnly?: boolean): Observable<SubjectModel> {
    const endpoint = super.getEndpoint('models', id);

    let httpParams = new HttpParams();
    if (version !== null && version !== undefined) {
      httpParams = httpParams.set('version', String(version));
    }
    if (enabledOnly !== null && enabledOnly !== undefined) {
      httpParams = httpParams.set('enabledOnly', String(enabledOnly));
    }
    if (aliveOnly !== null && aliveOnly !== undefined) {
      httpParams = httpParams.set('aliveOnly', String(aliveOnly));
    }

    return this.http.get<SubjectModel>(endpoint,
      { withCredentials: super.getWithCredentialsOption(), params: httpParams })
      .pipe(map(response => response as SubjectModel));
  }

  // MD03 POST /api/v1/models
  addSubjectModel(subjectModel: SubjectModelNew): Observable<SubjectModel> {
    const endpoint = super.getEndpoint('models');

    return this.http.post<SubjectModel>(endpoint, subjectModel,
      { withCredentials: super.getWithCredentialsOption() })
      .pipe(map(response => response as SubjectModel));
  }

  // MD04 PUT /api/v1/models/{modelId}
  updateSubjectModel(updateModel: SubjectModelUpdate): Observable<any> {
    const endpoint = super.getEndpoint('models', updateModel.id);

    return this.http.put<SubjectModel>(endpoint, updateModel,
      { withCredentials: super.getWithCredentialsOption() })
      .pipe(map(response => response as SubjectModel));
  }

  // MD05 GET /api/v1/models/{modelId}/export
  exportSubjectModel(id: string): Observable<Blob> {
    const endpoint = super.getEndpoint('models', id, 'export');

    return this.http.get(endpoint, {
      withCredentials: super.getWithCredentialsOption(), responseType: 'blob'
    });
  }

  // MD06 POST /api/v1/models/import
  importSubjectModel(file: File): Observable<HttpEvent<{}>> {
    const formData = new FormData();
    formData.append('file', file, file.name);

    const endpoint = super.getEndpoint('models', 'import');

    const req = new HttpRequest('PUT', endpoint, formData,
      { withCredentials: super.getWithCredentialsOption() });
    return this.http.request(req);
  }

  // MD07 PUT /api/v1/models/{modelId}/image
  updateSubjectModelImage(modelId: string, file: File): Observable<HttpEvent<{}>> {
    const formData = new FormData();
    formData.append('file', file, file.name);

    const endpoint = super.getEndpoint('models', modelId, 'image');

    const req = new HttpRequest('PUT', endpoint, formData,
      { withCredentials: super.getWithCredentialsOption() });
    return this.http.request(req);
  }

  // MD08 PUT /api/v1/models/{modelId}
  deleteSubjectModel(modelId: string): Observable<HttpEvent<{}>> {

    const endpoint = super.getEndpoint('models', modelId);

    const req = new HttpRequest('DELETE', endpoint,
      { withCredentials: super.getWithCredentialsOption() });
    return this.http.request(req);
  }

  // MD09 POST /api/v1/models/{modelId}/clone
  cloneSubjectModel(cloneModel: SubjectModelClone): Observable<any> {
    const endpoint = super.getEndpoint('models', cloneModel.id, 'clone');

    return this.http.post<SubjectModel>(endpoint, cloneModel,
      { withCredentials: super.getWithCredentialsOption() });
  }
}
